import React from "react"
import Index from "./Index"
import { contentLayout, modules } from "../config/const"
import { useUser } from "../contexts/UserContext"
import Forbidden from "./Forbidden"

function ViewPos (){
  const {user} = useUser()
  let view = contentLayout[modules.POSList]
  if(user.permissions.views.length && !user.permissions.views.join().includes(modules.POSList.toLowerCase())){
    view = Forbidden
  }
  return(
  <Index content={view} module={modules.POSList}></Index>
 )
}

export default ViewPos